// removed by extract-text-webpack-plugin
module.exports = {"navigationControls":"map-module__navigationControls___DVY5u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map/map.module.scss
// module id = 618
// module chunks = 0 1